// src/components/BrandBar.jsx
import React from "react";

/**
 * Minimal brand-only header for landing pages.
 * - No nav items
 * - Sticks to top
 * - Reuses the same logo asset/path as Navbar (update src as needed)
 */
export default function BrandBar() {
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-slate-200">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 h-16 flex items-center">
        <a href="#/home" className="flex items-center gap-3 group">
          <img
            src="content/images/ethira-logo.png"         // <-- match whatever Navbar uses
            alt="Ethira logo"
            className="h-7 w-auto"
          />
          <span className="text-lg font-semibold text-[#003366] group-hover:opacity-90">
            Ethira Property Group
          </span>
        </a>
      </div>
    </header>
  );
}
